'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bindActions = undefined;

var _Dom = require('common/Dom');

var _Dom2 = _interopRequireDefault(_Dom);

var _handlers = require('scripts/components/Cart/handlers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setInlineCartCheckoutButtonDisabledStatus = function setInlineCartCheckoutButtonDisabledStatus() {
  var policyAcknowledgementIsChecked = $(_Dom2.default.inlineCartPolicyAcknowledgement).prop('checked'),
      $checkoutButton = $(_Dom2.default.checkoutBtn),
      checkoutButtonHref = $checkoutButton.attr('data-href');

  if (policyAcknowledgementIsChecked) {
    $checkoutButton.removeClass('button--disabled').attr('href', checkoutButtonHref);
  } else {
    $checkoutButton.addClass('button--disabled').attr('href', null);
  }
};

var OVER_LIMIT_MESSAGE = 'Sorry, you have reached the maximum quantity of this product.';

var bindActions = exports.bindActions = function bindActions() {
  $(document).on('cart.ready', function () {
    (0, _handlers.setCartState)();
    (0, _handlers.updateCart)();
    (0, _handlers.updateSubtotal)();
    setInlineCartCheckoutButtonDisabledStatus();
  });

  $(document).on('cart.requestComplete', function (event) {
    (0, _handlers.setCartState)();
    (0, _handlers.updateCart)();
    (0, _handlers.updateSubtotal)();
  });

  $(_Dom2.default.atcForm).on('submit', function (event) {
    var $form = $(event.currentTarget);
    var field = $form.serializeArray().find(function (field) {
      return field.name === 'id';
    });
    var quantityLimit = parseInt(event.target.getAttribute('data-quantity-limit'));
    var productType = event.target.getAttribute('data-product-type');

    event.preventDefault();

    if (!quantityLimit && productType === 'medical-thermometers') {
      quantityLimit = 2;
    }

    if (quantityLimit) {
      window.CartJS.getCart().then(function (cart) {
        var foundItem = cart.items.find(function (item) {
          return item.id === parseInt(field.value);
        });
        // check if item exists in the cart already
        if (foundItem !== undefined && foundItem) {
          // check for current quantity
          var newQuantity = foundItem.quantity + 1;

          if (quantityLimit && newQuantity > quantityLimit) {
            alert(OVER_LIMIT_MESSAGE);
            return;
          } else {
            (0, _handlers.addCartItem)(field.value);
          }
        } else {
          (0, _handlers.addCartItem)(field.value);
        }
      }).catch(function (err) {
        console.error('error getting cart', err);
      });
    } else {
      (0, _handlers.addCartItem)(field.value);
    }
  });

  $(_Dom2.default.cartShow).on('click', function (event) {
    event.preventDefault();
    (0, _handlers.showCart)();
  });

  $(_Dom2.default.cartHide).on('click', function (event) {
    event.preventDefault();
    (0, _handlers.hideCart)();
  });

  $(_Dom2.default.overlay).on('click', function (event) {
    (0, _handlers.hideCart)();
  });

  $(_Dom2.default.inlineCart).on('change', '[data-quantity-number]', function () {
    (0, _handlers.updateQuantityByText)($(this));
  });

  $(_Dom2.default.inlineCart).on('click', '[data-quantity-change]', function () {
    (0, _handlers.updateQuantityByIncrement)($(this));
  });

  $(_Dom2.default.productId).on('click', function (event) {
    var productType = $(event.target).attr('data-product-type');
    var quantityLimit = $(event.target).attr('data-quantity-limit');
    var atcId = $(event.target).attr('data-atc-product-id');

    event.preventDefault();

    if (!quantityLimit && productType === 'medical-thermometers') {
      quantityLimit = 2;
    }

    if (quantityLimit) {
      window.CartJS.getCart().then(function (cart) {
        var foundItem = cart.items.find(function (item) {
          return item.id === parseInt(atcId);
        });
        // check if item exists in the cart already
        if (foundItem !== undefined && foundItem) {
          // check for current quantity
          var newQuantity = foundItem.quantity + 1;
          if (quantityLimit && newQuantity > quantityLimit) {
            alert(OVER_LIMIT_MESSAGE);
            return;
          } else {
            (0, _handlers.addCartItem)(atcId, 1);
          }
        } else {
          (0, _handlers.addCartItem)(atcId, 1);
        }
      }).catch(function (err) {
        console.error('error getting cart', err);
      });
    } else {
      (0, _handlers.addCartItem)(atcId, 1);
    }
  });

  $(_Dom2.default.inlineCartPolicyAcknowledgement).on('change', setInlineCartCheckoutButtonDisabledStatus);
};